import React, { useEffect, useState, useRef } from "react";
import VisitDetailsList from "./VisitDetailsList";
import CardBasic from "lib/cards/CardBasic";
import TableHeader from "components/TableHeader/TableHeader";
import { useCommonSortFilterHook } from "hooks/common/useCommonSortFilterHook";
import { useWoundManagementHook } from "hooks/woundManagement/useWoundManagementHook";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
const VisitListing = () => {
  const {
    currentPage,
    pageSize,
    search: visitSearch,
    sortData,
    onSearch,
    onSortData,
    onUpdatePage,
  } = useCommonSortFilterHook("Wound Management");

  const gridRef = useRef();
  const activeTab = sessionStorage.getItem("activeTab") || "Needs Review";
  const [tableColumns, setTableColumns] = useState([
    { header: "Visit Date", field: "visitDate", show: true },
    { header: "Assessed By", field: "assessedBy", show: true },
    { header: "Assessment Status", field: "adminAction", show: true },
    { header: "No. of Active Wounds", field: "activeWoundCount", show: true },
  ]);

  const { visitListing, visitListingData, isVisitListUninitialized } = useWoundManagementHook();

  const updatePage = (page, limit) => {
    onUpdatePage(page, limit);
    fetchVisitList();
  };

  const handleSearch = (searchString) => {
    onSearch(searchString);
    fetchVisitList();
  };

  const fetchVisitList = async () => {
    const sortColumn = sortData.current?.[0]?.colId;
    const sortOrder = sortData.current?.[0]?.sort;

    await visitListing({
      page: currentPage.current,
      pageSize: pageSize.current,
      adminAction: activeTab === "All" ? "" : "Needs Review",
      searchText: visitSearch.current,
      sortColumn: sortColumn ?? "createdAt",
      sortDirection: sortOrder ? (sortOrder === "asc" ? 1 : -1) : -1,
    });
  };

  // Effect to handle API calls when relevant dependencies change
  useEffect(() => {
    fetchVisitList();
  }, [activeTab]);
  return (
    <div>
      <div className="flex-between-middle flex-md-row flex-column my-16">
        <h2 className="h1 mb-md-0">Visits</h2>
      </div>
      <CardBasic
        className="d-inline-block w-100 user-theme-card"
        headerClassName="py-0"
        header={<TableHeader setSearch={handleSearch} search={visitSearch.current} module="Wound Management" />}
      >
        <VisitDetailsList
          visitData={visitListingData?.data}
          tableColumns={tableColumns}
          gridRef={gridRef}
          isVisitListUninitialized={isVisitListUninitialized}
          updatePage={updatePage}
          VisitDataPage={visitListingData}
          onSortData={onSortData}
          sortData={sortData}
          VisitList={fetchVisitList}
          module="Wound Management"
        />
      </CardBasic>
    </div>
  );
};

export default VisitListing;
